import * as Device from "expo-device"
import * as Notifications from "expo-notifications"
import { Platform } from "react-native"
import * as TaskManager from "expo-task-manager"
import { getSecondFromNow } from "@Utils/utils"
import Constants from "expo-constants"

const { eas } = Constants.expoConfig.extra

const BACKGROUND_NOTIFICATION_TASK = "BACKGROUND-NOTIFICATION-TASK"

import { messaging, getToken, onMessage } from "@Services/FirebaseConfig";

export async function registerForPushNotigetfication() {
  if (Platform.OS === "web") {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging);
      return token;
    }
  } else {
    const { status } = await Notifications.requestPermissionsAsync();
    if (status === "granted") {
      const token = (await Notifications.getExpoPushTokenAsync()).data;
      console.log("Mobile Token:", token);
      return token;
    }
  }
}

const defineNotificationBackgroundTask = () => {
    TaskManager.defineTask(BACKGROUND_NOTIFICATION_TASK, ({ data, error, executionInfo }) => {
        // Do something with the notification data
    })

    Notifications.registerTaskAsync(BACKGROUND_NOTIFICATION_TASK)
}

async function registerForPushNotificationsAsync() {
    const token = await registerForPushNotigetfication();

    if (Platform.OS === "android") {
        await Notifications.setNotificationChannelAsync("default", {
            name: "default",
            importance: Notifications.AndroidImportance.MAX,
            vibrationPattern: [0, 250, 250, 250],
            lightColor: "#FF231F7C"
        })
    }

    // if (Device.isDevice) {
    //     const { status: existingStatus } = await Notifications.getPermissionsAsync()
    //     let finalStatus = existingStatus
    //     if (existingStatus !== "granted") {
    //         const { status } = await Notifications.requestPermissionsAsync()
    //         finalStatus = status
    //     }
    //     if (finalStatus !== "granted") {
    //         //alert("Failed to get push token for push notification!")
    //         return
    //     }
    //     // Learn more about projectId:
    //     // https://docs.expo.dev/push-notifications/push-notifications-setup/#configure-projectid
    //     console.log("Getting notification with project ID", eas?.projectId)
    //     token = (await Notifications.getDevicePushTokenAsync({ projectId: eas?.projectId })).data
    //     console.log(token)
    // } else {
    //     // alert("Must use physical device for Push Notifications")
    // }

    return token;
    
}

async function schedulePushNotification() {
    console.log("should show notification")
    await Notifications.scheduleNotificationAsync({
        content: {
            title: "Notification scheduled",
            body: "Here is the notification body",
            data: { data: "goes here" }
        },
        trigger: { seconds: 2 }
    })
}

async function schedulePushNotificationForDate(date, notificationTitle, notificationBody) {
    //date format should be YYYY-MM-dd HH:mm
    let seconds = getSecondFromNow(date)
    if (seconds > 0) {
        await Notifications.scheduleNotificationAsync({
            content: {
                title: notificationTitle,
                body: `${notificationBody} `
                // data: { data: "goes here" }
            },
            trigger: { seconds: seconds }
        })
    }
}

const enableNotificationListenner = () => {
    Notifications.addNotificationResponseReceivedListener((response) => {
        // console.warn(response)
    })
}

const cancelNotificationSchedule = async () => {
    try {
        await Notifications.cancelAllScheduledNotificationsAsync()
    } catch (e) {}
}

export const NotificationService = {
    registerForPushNotificationsAsync,
    schedulePushNotification,
    defineNotificationBackgroundTask,
    enableNotificationListenner,
    schedulePushNotificationForDate,
    cancelNotificationSchedule
}
